import type { CoreWork } from "~/types/coreWork";

export function useCoreWork() {
   const { log, logError } = useDebugger();
   const { getProfileContent } = useProfile();
   const { setModal } = useGlobalModal();
   const { setPageTitle } = useBreadcrumbs();

   const $apiFetch = useNuxtApp().$apiFetch as typeof $fetch;
   // STATE ========================
   const coreWork = useState<CoreWork.Resource | null>("coreWork", () => null);

   // QUERY ========================
   const queryCoreWork = async (slug: string): Promise<CoreWork.Resource> => {
      try {
         const data = await $apiFetch<CoreWork.Resource>(`core-works/${slug}`);
         setPageTitle(data?.title);
         return data;
      } catch (err) {
         logError("queryCoreWork failed", err);
         throw err;
      }
   };

   const saveCoreWorkToProfile = async (
      slug: string,
      method: "POST" | "DELETE" = "POST",
   ): Promise<CoreWork.SaveResponse> => {
      try {
         const data = await $apiFetch<CoreWork.SaveResponse>(
            `core-works/${slug}/save`,
            { method },
         );
         log(`Profile Core Work ${method}: `, data);
         getProfileContent("coreWorks").catch(() => {}); // best-effort refresh
         return data;
      } catch (err) {
         logError("saveCoreWorkToProfile failed", err);
         throw err;
      }
   };

   // GETTERS ========================
   const setCoreWork = (val: CoreWork.Resource | null) => {
      coreWork.value = val;
   };
   const getCoreWork = computed(() => {
      return coreWork.value;
   });

   // RETURN ========================
   return {
      queryCoreWork,
      setCoreWork,
      coreWork: getCoreWork,
      saveCoreWorkToProfile,
   };
}
